// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"styles_scrollWrapper__oSB40","description":"styles_description__by6bM","submitButton":"styles_submitButton__Y9aB1","block":"styles_block__JoKo7"};